import React, { useEffect, useState } from "react";
import { List, ListItem, ListItemIcon, ListItemText, Divider, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core";

import Print from "@material-ui/icons/Print";
import Language from "@material-ui/icons/Language";
import {createHistory, hasPermission} from '../../sc-utilities';
import { connect } from 'react-redux';
import * as action from "../../np-core/User/store/userActions";
import * as actions from "../store/profileActions";
import SettingsApplications from "@material-ui/icons/SettingsApplications";
import LastUsedPrinterForm from "./LastUsedPrinterForm";
import LanguageSelect from "./LanguageSelect";
import { Redirect } from 'react-router-dom';
import TwoFactorAuthentication from "./TwoFactorAuthentication";

const styles = theme => ({
    root: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(2)
    }
});

const YourSettings = props => {
    const { classes, fetchUserSettings, onFetchPrinters, activeCustomerID, translations, permissions } = props;
    const [lastUsedPrinterFormState, setLastUsedPrinterFormState] = useState({ open: false, data: [] });
    const [languageSelectOpen, setLanguageSelectOpen] = useState(false);

    const [userSettings, setUserSettings] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const result = await fetchUserSettings({ ActiveCustomerID: activeCustomerID });
            setUserSettings(result);
        };
        fetchData();
    }, [fetchUserSettings, activeCustomerID, languageSelectOpen]);



    const handleLastUsedPrinterFromOpen = async () => {
        let printers = await onFetchPrinters({ ActiveCustomerID: activeCustomerID });
        setLastUsedPrinterFormState({ open: true, data: printers });
    };

    const handleCloseLastUsedPrinterForm = async () => {
        const result = await fetchUserSettings({ ActiveCustomerID: activeCustomerID });
        setUserSettings(result);
        setLastUsedPrinterFormState({ open: false, data: [] });
    };

    const openLanguageSelect = () => {
        setLanguageSelectOpen(true);
    };

    const [redirect, setRedirect] = useState({ redirect: false, path: null });

    const handleDefaultTypicalProblemsOpen = async () => {
        createHistory();
        setRedirect({ redirect: true, path: "/typical-problem-settings" });
    };


    if (redirect.redirect) {
        return <Redirect to={redirect.path} />;
    }

    return (
        <Paper className={classes.root} >
            <h3>{translations["qt_settings"] || 'QT Settings:'} </h3>
            <List style={{ display: "inline-grid" }} component="ul">
                <ListItem button onClick={handleDefaultTypicalProblemsOpen} >
                    <ListItemIcon>
                        <SettingsApplications />
                    </ListItemIcon>
                    <ListItemText primary={translations["typical_problems"] || "Typical problems"} />
                </ListItem>

            </List>
            <Divider />
            <h3>{translations["web_ui_settings"] || ' Web UI Settings:'}</h3>
            <ListItem button onClick={handleLastUsedPrinterFromOpen}>
                <ListItemIcon>
                    <Print />
                </ListItemIcon>
                <ListItemText primary={translations["last_used_printer"] || "Last used printer"} />
            </ListItem>
            <ListItem button onClick={openLanguageSelect}>
                <ListItemIcon>
                    <Language />
                </ListItemIcon>
                <ListItemText primary={translations["change_language"] || "Change language"} />
            </ListItem>
            <Divider />
            {hasPermission(permissions, 'update_user_authentication') &&
                <TwoFactorAuthentication userSettings={userSettings} fetchUserSettings={fetchUserSettings} setUserSettings={setUserSettings}/>
            }

            {lastUsedPrinterFormState.open ? <LastUsedPrinterForm
                lastUsedPrinterFormState={lastUsedPrinterFormState}
                handleCloseLastUsedPrinterForm={handleCloseLastUsedPrinterForm}
            />
                : null}
            {languageSelectOpen ?
                <LanguageSelect
                    modalState={languageSelectOpen}
                    handleCloseLanguageSelect={() => setLanguageSelectOpen(false)}
                ></LanguageSelect> : null}
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        loggedUser: state.core.login.user,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUserSettings: params => dispatch(action.fetchUserSettings(params)),
        onFetchPrinters: params => dispatch(actions.fetchPrinters(params)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(YourSettings));

